import { Component } from '@angular/core';
import { FieldWorkerUnavailableDay, FieldWorkerLink } from 'src/shared/api';
import { FormConfig, CustomFormAccessor } from '../../form-cva.component';
import { Validators, NgControl, FormBuilder } from '@angular/forms';
import { CustomValidators } from 'src/shared/validators/custom-validators';
import { takeUntil } from 'rxjs/operators';

export interface FieldWorkerMultipleUnavailableDay {
	id?: number;
	startDate?: string;
	endDate?: string;
	reason?: string;
	fieldWorker?: FieldWorkerLink;
}

export const unavailableDayMultipleFormConfig: FormConfig<FieldWorkerMultipleUnavailableDay> = {
	id: [''],
	startDate: ['', [Validators.required, CustomValidators.isNotBeforeToday]],
	endDate: ['', [Validators.required, CustomValidators.isNotBeforeToday]],
	reason: [''],
	fieldWorker: [''],
};

@Component({
	selector: 'rpshared-unavailable-multiple-days',
	templateUrl: './unavailable-multiple-days.component.html',
	styleUrls: ['./unavailable-multiple-days.component.scss'],
})
export class UnavailableMultipleDaysComponent extends CustomFormAccessor<
	FieldWorkerMultipleUnavailableDay
> {
	constructor(public ngControl: NgControl, public fb: FormBuilder) {
		super(ngControl, fb, unavailableDayMultipleFormConfig);
	}

	// model --> view
	writeValue(value: FieldWorkerUnavailableDay): void {
		super.writeValue(value);
	}

	// view --> model
	registerOnChange(fn: (value: FieldWorkerUnavailableDay) => void) {
		this.form.valueChanges.pipe(takeUntil(this.destroyed)).subscribe(fn);
	}
}
